import type { ReactElement } from 'react';

import CloseBtn from '../Icons/CloseBtn';
import classes from './MultilineNotification.module.css';

type Props = {
    messages: (string | ReactElement)[];
    isError?: boolean;
    isBlue?: boolean;
    extraClass?: string;
    handleCloseMsg?: () => void;
};

/**
 * @deprecated
 *
 * Use Notification instead. This is considered legacy.
 * @link ptrn-fe/src/Components/UI_Library/Notification/Notification.tsx
 *
 * Notification message prop takes a ReactNode and can render a list instead a div etc
 */
const MultilineNotification = ({ messages, isError, isBlue, extraClass, handleCloseMsg }: Props) => (
    <div
        className={`alert message-box ${isError ? 'alert-danger' : 'alert-success'} ${
            isBlue ? 'blue' : ''
        } ${extraClass}`}
    >
        <div className={classes.messagesBox}>
            {messages.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key -- No other better key
                <span key={index} className={classes.message}>
                    {item}
                </span>
            ))}
        </div>
        <div>
            <button type="button" className="close" onClick={handleCloseMsg}>
                <CloseBtn />
            </button>
        </div>
    </div>
);

export default MultilineNotification;
